import script from "./DateBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateBox.vue?vue&type=script&setup=true&lang=ts"

import "./DateBox.vue?vue&type=style&index=0&id=117a9205&scoped=true&lang=css"

import exportComponent from "C:\\Users\\okuharamayo\\hoikm\\pcare\\src\\ui-iikum\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-117a9205"]])

export default __exports__